import pako from 'pako';
import { Buffer } from 'buffer';
import { parseISO, isToday, format } from 'date-fns';
//eslint-disable-next-line
export const decompressData = (compressedData: string | string[]) => {
  if (!compressedData || compressedData.length === 0) {
    return [];
  }
  // eslint-disable-next-line
  let base64Data: string;

  // If compressedData is an array, get first item
  if (Array.isArray(compressedData)) {
    base64Data = compressedData[0];
  } else if (typeof compressedData === 'string') {
    base64Data = compressedData;
  } else {
    console.warn(
      'decompressData: Unexpected input type',
      typeof compressedData,
    );
    return [];
  }

  try {
    const compressedBuffer = Buffer.from(base64Data, 'base64');
    const decompressed = pako.ungzip(compressedBuffer, { to: 'string' });
    return JSON.parse(decompressed);
  } catch (error) {
    console.error('Failed to decompress data:', error);
    return [];
  }
};

export const normalizeExternalUrl = (url: unknown): string | null => {
  if (typeof url !== 'string') {
    return null;
  }

  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    return null;
  }

  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmedUrl);
  const isDomainLike =
    !/\s/.test(trimmedUrl) && /^[^/?#]+\.[^/?#]+/.test(trimmedUrl);
  const normalizedUrl = hasScheme
    ? trimmedUrl
    : trimmedUrl.startsWith('//')
    ? `https:${trimmedUrl}`
    : isDomainLike
    ? `https://${trimmedUrl}`
    : null;

  if (!normalizedUrl) {
    return null;
  }

  try {
    const parsedUrl = new URL(normalizedUrl);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
      ? parsedUrl.href
      : null;
  } catch {
    return null;
  }
};
//eslint-disable-next-line
export const compressData = (data: any) => {
  const stringifiedData = JSON.stringify(data);
  const compressed = pako.gzip(stringifiedData);
  return Buffer.from(compressed).toString('base64'); // Convert to base64 for storage or transmission
};

export const formatFriendlyTime = (timeString: string | undefined): string => {
  if (!timeString) {
    return 'Unknown time';
  }

  try {
    const date = parseISO(timeString);

    if (isToday(date)) {
      return `Today, ${format(date, 'HH:mm')}`;
    }

    return format(date, 'dd MMM yyyy, HH:mm');
  } catch (error) {
    console.error('Invalid time string:', timeString, error);
    return 'Invalid time';
  }
};
